<div *ngIf="areTheInitialRegistrationStepsIncomplete()" class="row mt-3 mb-2">
  <div class="col-12">
    <div class="idb-progress-bar-wrapper">
      <div class="bar-and-steps-wrapper">
        <div class="row">
          <!--Step1-->
          <div class="col-3 p-0 m-0">
            <div
              class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center first"
              [ngClass]="
                !isFullNameRegistrationCompleted &&
                !isPetChipNumberRegistrationCompleted &&
                !isMembershipSelectionCompleted &&
                !isWelcomePackSelectCompleted
                  ? 'progress-bar-step-completed'
                  : ''
              "
            >
              <span class="progress-bar-special-text"> Your details</span>
            </div>
          </div>

          <!--Step2-->
          <div class="col-3 p-0 m-0">
            <div
              class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center second"
              [ngClass]="
                isFullNameRegistrationCompleted &&
                !isPetChipNumberRegistrationCompleted &&
                !isMembershipSelectionCompleted &&
                !isWelcomePackSelectCompleted
                  ? 'progress-bar-step-completed'
                  : ''
              "
            >
              <span class="progress-bar-special-text"> Pet details</span>
            </div>
          </div>

          <!--Step3-->
          <div class="col-3 p-0 m-0">
            <div
              class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center third"
              [ngClass]="
                isFullNameRegistrationCompleted &&
                isPetChipNumberRegistrationCompleted &&
                !isMembershipSelectionCompleted &&
                !isWelcomePackSelectCompleted
                  ? 'progress-bar-step-completed'
                  : ''
              "
            >
              <span class="progress-bar-special-text"> Select plan</span>
            </div>
          </div>

          <!--Step4-->
          <div class="col-3 p-0 m-0">
            <div
              class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center last"
              [ngClass]="
                isFullNameRegistrationCompleted &&
                isPetChipNumberRegistrationCompleted &&
                isMembershipSelectionCompleted &&
                !isWelcomePackSelectCompleted
                  ? 'progress-bar-step-completed'
                  : ''
              "
            >
              <span class="progress-bar-special-text"> 4 weeks free pet insurance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
